<script setup lang="ts">
import { LoaderCircle } from 'lucide-vue-next'
import { onBeforeUnmount, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import BrandMark from '@/components/BrandMark.vue'
import { useAuthStore } from '@/stores/auth'
const auth = useAuthStore()
const router = useRouter()
let timer: ReturnType<typeof setInterval> | undefined
const check = async () => { if (await auth.refreshAccountStatus() === 'active') await router.replace('/app/manager') }
onMounted(() => { void check(); timer = setInterval(() => void check(), 2_000) })
onBeforeUnmount(() => { if (timer) clearInterval(timer) })
</script>

<template>
  <div class="centered-gate">
    <BrandMark />
    <div class="gate-card">
      <span class="gate-icon"><LoaderCircle class="spin" :size="28" /></span>
      <span class="eyebrow">Account provisioning</span>
      <h1>Preparing your Manager</h1>
      <p>Your credits are confirmed. We’re setting up your Manager, its private memory, a secure credential vault, and your workspace.</p>
    </div>
  </div>
</template>
